<div>
  @for (groupTask of groups(); track groupTask.id) {
    <ri-resolution-ui-panel
      class="mb-4 block border-0 border-b border-solid border-gray-300 pb-4"
      [disableExpand]="groupTask.tasks.length <= 1"
      [hideExpand]="groupTask.tasks[0].taskStatus === taskItemStatus.Completed"
    >
      <ri-resolution-ui-panel-header>
        <ng-template #header>
          <div class="relative">
            @if (groupTask.globalEligible) {
              <mat-icon
                fontSet="material-symbols-outlined"
                class="absolute right-0 top-1/2 -translate-y-1/2 text-base leading-none text-r1-blue-500"
                title="Global Eligible"
                >public</mat-icon
              >
            }
          @switch (groupTask.taskType) {
            @case (taskTypes.MailPackageTaskItem) {
              <ri-resolution-ui-mail-package-group-template
                [group]="groupTask"
              ></ri-resolution-ui-mail-package-group-template>
            }
            @case (taskTypes.CallPayerTaskItem) {
              <ri-resolution-ui-call-payer-group-template
                [group]="groupTask"
              ></ri-resolution-ui-call-payer-group-template>
            }
            @case (taskTypes.CreatePackageTaskItem) {
              <ri-resolution-ui-create-package-group-template
                [group]="groupTask"
              ></ri-resolution-ui-create-package-group-template>
            }
            @case (taskTypes.ReviewTaskItem) {
              <ri-resolution-ui-review-group-template
                [group]="groupTask"
              ></ri-resolution-ui-review-group-template>
            }
            @case (taskTypes.ManualPortalTaskItem) {
              <ri-resolution-ui-manual-portal-group-template
                [group]="groupTask"
              ></ri-resolution-ui-manual-portal-group-template>
            }
            <!-- @case (taskTypes.PayerPortalTaskItem) {
              <ri-resolution-ui-payer-portal-group-template
                [group]="groupTask"
              ></ri-resolution-ui-payer-portal-group-template>
            } -->
            @default {
              Unknown task type
            }
          }
          </div>
        </ng-template>
      </ri-resolution-ui-panel-header>
      <ri-resolution-ui-panel-content>
        <div class="flex flex-col gap-y-2">
          @for (task of groupTask.tasks; track task.id) {
            <ri-resolution-ui-sidebar-task
              [task]="task"
              [attr.data-testid]="'sidebar-task-' + task.id"
            ></ri-resolution-ui-sidebar-task>
          }
        </div>
      </ri-resolution-ui-panel-content>
    </ri-resolution-ui-panel>
  }
  @if (showLoader()) {
    <div class="text-center">
      <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem"></i>
    </div>
  }
</div>
